<template>
  <div>
    <Head />

    <nav class="breadcrumb_box" aria-label="breadcrumb" v-if="PostData">
      <ol class="breadcrumb container">
        <li class="breadcrumb-item"><router-link to="/">{{ $t('首頁') }}</router-link></li>
        <li class="breadcrumb-item active" aria-current="page">{{ PostData.Post.Title }}</li>
      </ol>
    </nav>
    <div class="wrapper list_main" v-if="PostData">
      <svg class="bg"></svg>
      <!-- 列表內頁 -->
      <section class="">
        <div class="container">
          <div class="main_box">
            <div class="title_box">
              <h1>{{ PostData.Post.Title }}</h1>
              <div class="social_box">
                <ul class="social">
                  <li>
                    <a :href="PostData.ShareUrl_Facebook" target="_blank" :title="$t('分享至Facebook, 另開新視窗')">
                      <img src="img/icon_fb2.svg" alt="">
                    </a>
                  </li>
                  <li>
                    <a :href="PostData.ShareUrl_Twitter" target="_blank" :title="$t('分享至X, 另開新視窗')">
                      <img src="img/icon_twitter2.svg" alt="">
                    </a>
                  </li>
                </ul>
                <p class="time">{{ PostData.Post.PublicStartTime | timeString("YYYY-MM-DD") }}</p>
              </div>
            </div>
            <div class="list_main_carousel_box">
              <slick class="list_main_carousel" v-if="Slideshows" :options="{
                autoplay: true,
                autoplaySpeed: 5000,
                slidesToShow: 2,
                slidesToScroll: 1,
                responsive: [
                  {
                    breakpoint: 767.98,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                    }
                  }
                ]
              }">
                <div class="carousel" v-for="(Slideshow, index) in Slideshows" :key="index">
                  <div class="box">
                    <img :src="PostData.SiteUrl + Slideshow.Url" :alt="Slideshow.DisplayName" />
                  </div>
                </div>
              </slick>
            </div>
            <div class="text" v-html="PostData.Post.Content">
            </div>
            <div class="download" v-if="Attachments">
              <h2>{{ $t('檔案下載') }}</h2>
              <div class="file_box">
                <a :href="PostData.SiteUrl +
                  '/Platform/Html/Download?FId=' +
                  Attachment.FId
                  " target="_blank" :title="$t('下載') + Attachment.DisplayName + $t(', 另開新視窗')"
                  v-for="( Attachment, index ) in Attachments " :key="index">
                  <p>{{ Attachment.DisplayName }}</p>
                  <div class="file">{{ Attachment.Extension }}</div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div><!-- wrapper -->

    <Footer />
  </div>
</template>
<script>
import Head from "@/components/Head.vue";
import Footer from "@/components/Footer.vue";

import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

const messages = {
  zh_tw: {
    "首頁": "首頁",
    "分享至Facebook, 另開新視窗": "分享至Facebook, 另開新視窗",
    "分享至X, 另開新視窗": "分享至X, 另開新視窗",
    "檔案下載": "檔案下載",
    "下載": "下載",
    ", 另開新視窗": ", 另開新視窗",
  },
  en: {
    "首頁": "Home Page",
    "分享至Facebook, 另開新視窗": "Share to Facebook (opens in a new window)",
    "分享至X, 另開新視窗": "Share to X (opens in a new window)",
    "檔案下載": "Download the files",
    "下載": "Download",
    ", 另開新視窗": "open a new window",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

import Slick from "vue-slick";

import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";

export default {
  name: "Post",
  i18n,
  components: {
    Head,
    Footer,
    Slick
  },
  data() {
    return {
      PostData: null,
      Attachments: null,
      Slideshows: null,
      local: "zh_tw",
    };
  },
  beforeRouteUpdate(to, from, next) {
    Vue.axios
      .get(
        this.$store.state.src + this.$store.state.subDirectory + "/Html/Post",
        {
          params: { PId: to.params.PId, CId: to.params.CId },
        }
      )
      .then((response) => {
        this.PostData = response.data;
        if (this.PostData.Post.Attachment != "[]") {
          this.Attachments = JSON.parse(this.PostData.Post.Attachment);
        } else {
          this.Attachments = null;
        }
        if (this.PostData.Post.Slideshow != "[]") {
          this.Slideshows = JSON.parse(this.PostData.Post.Slideshow);
        } else {
          this.Slideshows = null;
        }
      })
      .catch((error) => {
        console.log(error);
      });
    next();
  },
  created: function () {
    Vue.axios
      .get(
        this.$store.state.src + this.$store.state.subDirectory + "/Html/Post",
        {
          params: { PId: this.$route.params.PId, CId: this.$route.params.CId },
        }
      )
      .then((response) => {
        this.PostData = response.data;
        if (this.PostData.Post.Attachment != "[]") {
          this.Attachments = JSON.parse(this.PostData.Post.Attachment);
        }
        if (this.PostData.Post.Slideshow != "[]") {
          this.Slideshows = JSON.parse(this.PostData.Post.Slideshow);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    if ($cookies.isKey("dormitory_site_lang")) {
      i18n.locale = $cookies.get("dormitory_site_lang");
      this.local = $cookies.get("dormitory_site_lang");
    } else {
      i18n.locale = "zh_tw";
      this.local = "zh_tw";
    }
  },
  updated: function () {
  },
  methods: {
  },
};
</script>
